import React, { useEffect, useState } from 'react';
import { v2_document_type } from '../../../actions/v2/masterData';
import Select from 'react-select';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';

const SearchBar = ({ onSearch, onReset, projectId, encodedData }) => {
    const [filterData, setFilterData] = useState({
        keyword: { name: 'keyword', value: '' },
        tag: { name: 'tag', value: [], options: [] },
    });

    useEffect(() => {
        v2_document_type().then((res) => {
            if (res.status) {
                setFilterData((prev) => ({
                    ...prev,
                    tag: {
                        ...prev.tag, options: res.result.map((item) => ({
                            label: item.DOCUMENT_TYPE,
                            value: item.ID
                        })),
                    },
                }));


            }
        });
    }, [projectId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };
    useEffect(() => {
        handleSearch()
    }, [filterData.keyword.value, filterData.tag.value])

    const handleSearch = () => {
        const modelPayload = {
            keyword: filterData.keyword.value?.trim() || '',
            tag: filterData.tag.value.map((opt) => opt.value),
        };
        const encodedPayload = btoa(JSON.stringify(modelPayload));
        if (onSearch) onSearch(encodedPayload);
    };

    const handleMultiSelectChange = (selectedOptions) => {
        setFilterData((prev) => ({
            ...prev,
            tag: {
                ...prev.tag,
                value: selectedOptions || [],
            },
        }));
    };

    const handleReset = () => {
        const resetData = {
            keyword: { name: 'keyword', value: '' },
            tag: { name: 'tag', value: [], options: filterData.tag.options },
        };
        setFilterData(resetData);
        if (onReset) {
            onReset(resetData);
        }
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card card-mrg">
                    <div className="card-body card-body-search">
                        <form
                            className="row gy-12 gx-12 align-items-center"
                            onSubmit={handleSearch}
                        >
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <input
                                        type="text"
                                        name={filterData.keyword.name}
                                        value={filterData.keyword.value}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter Document Name, ID & Keywords..."
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <Select
                                        isMulti
                                        name="tag"
                                        value={filterData.tag.value}
                                        options={filterData.tag.options}
                                        onChange={handleMultiSelectChange}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="All Tags"
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    <Link
                                        className="btn btn-primary"
                                        to={{
                                            pathname: constant.Authedcomponent.addDocument.url,
                                            state: {
                                                data: encodedData,
                                            },
                                        }}
                                        style={{ backgroundColor: '#29577b', borderColor: '#29577b' }}
                                    >
                                        <i className="bx bx-plus align-middle" /> Add New Documents
                                    </Link>
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
